module.exports = __webpack_public_path__ + "media/images/selfpromo__button-4790db15e745634c240b2429d9ed4acb.png";